import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlistId", "audience", "teams", "value", "wasAutoShareChanged", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import sortBy from 'utils/sortBy';
import toArray from 'utils/toArray';
import FormField, { FormFieldAlignedContent } from 'components/FormField';
import InlineList from 'components/InlineList';
import RadioButtonOption from 'components/RadioButtonOption';
import Stack from 'components/Stack';
import Button from 'components/Button';
import { TeamPill } from 'components/Pill';
import ShadedCard from 'components/ShadedCard';
import Text from 'components/Text';
import Status from 'components/Status';
import TeamPickerModal from 'screens/TeamPickerModal';
import AutoShareInfo from './AutoShareInfo';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function sortTeams(teams) {
  return sortBy(teams, function (_ref) {
    var teamType = _ref.teamType;
    return teamType === null || teamType === void 0 ? void 0 : teamType.rank;
  });
}
function AutoShareField(_ref2) {
  var playlistId = _ref2.playlistId,
    audience = _ref2.audience,
    teams = _ref2.teams,
    value = _ref2.value,
    wasAutoShareChanged = _ref2.wasAutoShareChanged,
    onChange = _ref2.onChange,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var teamId = useUniqueId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTeamSelector = _useState2[0],
    setShowTeamSelector = _useState2[1];
  var type = value.type,
    shareTeams = value.teams;
  var nonhereditaryTeams = teams.filter(function (team) {
    return !(team !== null && team !== void 0 && team.isCalculated);
  });
  var selectableTeamIds = audience === 'teams' ? nonhereditaryTeams.map(function (_ref3) {
    var id = _ref3.id;
    return id;
  }) : undefined;
  var showTeamsList = type === 'teams';
  var orderedShareTeams = sortTeams(shareTeams);
  function handleChange(e) {
    var type = e.currentTarget.value;
    onChange({
      type: type,
      teams: shareTeams
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
        as: "span",
        label: t('form_autoshare_audience'),
        labelId: uniqueId
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          children: [/*#__PURE__*/_jsx(RadioButtonOption, {
            id: "autoshare_everyone_radiobttn",
            checked: type === 'everyone',
            value: "everyone",
            disabled: audience !== 'all',
            onChange: handleChange,
            label: t('state_everyone')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            id: "autoshare_teams_radiobttn",
            checked: type === 'teams',
            value: "teams",
            disabled: audience === 'admin',
            onChange: handleChange,
            label: t('state_selected_teams')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            id: "do_not_autoshare_radiobttn",
            checked: type === 'null',
            value: 'null',
            onChange: handleChange,
            label: t('state_do_not_share')
          })]
        })
      })), showTeamsList && /*#__PURE__*/_jsx(FormFieldAlignedContent, {
        children: /*#__PURE__*/_jsx(ShadedCard, {
          px: "s",
          py: "xs",
          children: /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
            as: "span",
            label: t('content_type_team_plural'),
            labelId: uniqueId,
            horizontal: false,
            id: teamId
          }, otherProps), {}, {
            children: /*#__PURE__*/_jsxs(Stack, {
              spacing: "xs",
              children: [/*#__PURE__*/_jsxs(InlineList, {
                spacing: "xxs",
                "aria-labelledby": teamId,
                children: [orderedShareTeams.map(function (team) {
                  return /*#__PURE__*/_jsx(TeamPill, {
                    team: team,
                    onClick: function onClick() {
                      return setShowTeamSelector(true);
                    }
                  }, team.id);
                }), orderedShareTeams.length === 0 && /*#__PURE__*/_jsx(Text, {
                  dimmed: true,
                  size: "s",
                  children: t('amount_none')
                })]
              }), /*#__PURE__*/_jsx(Button, {
                size: "medium",
                icon: "edit",
                onClick: function onClick() {
                  return setShowTeamSelector(true);
                },
                children: t(orderedShareTeams.length === 0 ? 'actions_add_teams' : 'actions_edit_teams')
              })]
            })
          }))
        })
      })]
    }), /*#__PURE__*/_jsx(Status, {
      mt: wasAutoShareChanged ? 's' : undefined,
      children: wasAutoShareChanged && /*#__PURE__*/_jsx(FormFieldAlignedContent, {
        children: /*#__PURE__*/_jsx(AutoShareInfo, {
          playlistId: playlistId,
          autoShare: value
        })
      })
    }), showTeamSelector && /*#__PURE__*/_jsx(TeamPickerModal, {
      defaultSelectedItems: shareTeams,
      selectableItemIds: selectableTeamIds,
      onSubmit: function onSubmit(_ref4) {
        var selectedItems = _ref4.selectedItems;
        onChange({
          type: 'teams',
          teams: sortTeams(toArray(selectedItems))
        });
        setShowTeamSelector(false);
      },
      onClose: function onClose() {
        return setShowTeamSelector(false);
      }
    })]
  });
}
export default AutoShareField;